import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PARK_DOCUMENT_LINE_ITEM } from "./apiRoutes";

interface UseGetCommentByLineItemIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommentByLineItemId = async (id: string) =>
  await axiosAuth.get(`${PARK_DOCUMENT_LINE_ITEM}/${id}/comments`);

const useGetCommentByLineItemId = ({
  id,
  queryParams,
}: UseGetCommentByLineItemIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["line-item-comment", id],
    queryFn: () => getCommentByLineItemId(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetCommentByLineItemId;
